import * as React from 'react'
import * as s from './ThreadList.scss'

export interface IThreadListProps {
  children: any
}

export const ThreadList = ({ children }: IThreadListProps) => (
  <div className={s.outer}>{children}</div>
)



// WEBPACK FOOTER //
// src/features/Messages/ThreadList/ThreadList.tsx